import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@core/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded border border-neutral-200 py-0.5 px-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 dark:border-neutral-800 dark:focus:ring-neutral-300",
  {
    variants: {
      variant: {
        success: "bg-transparent border-success-400 dark:border-success-600 text-success-400 dark:text-success-600",
        warning: "bg-transparent border-warning-400 dark:border-warning-600 text-warning-500",
        info: "bg-transparent border-info-400 dark:border-info-600 text-info-500",
        danger: "bg-transparent border-danger-400 dark:border-danger-600 text-danger-500",
        default:
          "border-transparent bg-neutral-900 text-neutral-50 hover:bg-neutral-900/80 dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-50/80",
        secondary:
          "border-transparent bg-neutral-100 text-neutral-900 hover:bg-neutral-100/80 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-800/80",
        destructive:
          "border-transparent bg-danger-500 text-neutral-50 hover:bg-danger-500/80 dark:bg-danger-900 dark:text-neutral-50 dark:hover:bg-danger-900/80",
        outline: "text-neutral-950 dark:text-neutral-50",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
